/**
 * Copyright (c) 2024-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

import { type FC, type ReactNode } from 'react'
import styled from 'styled-components'

export type Props =  {
  children: ReactNode,
  className?: string
}

const Header: FC<Props> = styled.div`
  border-radius: 0;

  & > * {
    padding-top: 100px;
    padding-bottom: 30px;
  }

  & h1, h2, h3, h4, h5 {
    vertical-align: baseline;
    font-weight: bold;
    color: ${props => props.theme.colors.primary};
  }

  & p {
    vertical-align: baseline;
    opacity: 0.7;
  }
`

Header.defaultProps = {
  className: 'header'
}


export default Header
